import { Info, X } from 'lucide-react';
import { ReactNode, useState } from 'react';

// 메뉴별 사용법 가이드 — 처음 방문이면 펼쳐서, 닫으면 기억(localStorage), '사용법 보기'로 재오픈.
export default function GuideCard({ id, title, children }: { id: string; title: string; children: ReactNode }) {
  const key = `guide_seen_${id}`;
  const [open, setOpen] = useState(() => {
    try { return localStorage.getItem(key) !== '1'; } catch { return true; }
  });

  const dismiss = () => {
    try { localStorage.setItem(key, '1'); } catch { /* noop */ }
    setOpen(false);
  };

  // 🎨 규격 V2(08-23) — 보라(indigo) 액센트 은퇴, 앰버 헤어라인 박스로.
  if (!open) {
    return (
      <button onClick={() => setOpen(true)} className="mx-4 mt-3 inline-flex items-center gap-1 text-[11.5px] text-dc-ink3 hover:text-dc-point transition-colors">
        <Info size={12} /> 사용법 보기
      </button>
    );
  }

  return (
    <div className="m-4 rounded-[10px] border border-dc-point/30 bg-dc-point/[0.05] px-4 py-3.5">
      <div className="flex items-center gap-2 mb-2.5">
        <Info size={15} className="text-dc-point" />
        <span className="text-dc-ink1 text-sm font-bold">{title}</span>
        <button onClick={dismiss} className="ml-auto text-dc-ink3 hover:text-dc-ink1 text-[11.5px] flex items-center gap-1">닫기 <X size={12} /></button>
      </div>
      <div className="text-dc-ink2 text-xs leading-relaxed">{children}</div>
    </div>
  );
}
